export default __webpack_public_path__ + "static/media/CaffeBg.58fe6f0d.jpg";